export default __webpack_public_path__ + "static/O0208-396cef94678fb8af1a270a649712b18e.png";